// window.addEventListener("error", (event) => {
//   console.error("🔥 Erro global capturado:", event.message, event.error);
// });

// window.addEventListener("unhandledrejection", (event) => {
//   console.error("🔥 Promessa não tratada:", event.reason);
// });



// import { createApp } from 'vue'
// import './style.css'
// import { createPinia } from 'pinia'
// import router from './router'
// import App from './App.vue'
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'



// const pinia = createPinia()
// pinia.use(piniaPluginPersistedstate)

// const app = createApp(App)

// app.use(router)
// app.use(pinia)

// app.mount('#app')

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import App from './App.vue'
import './style.css'

// Captura erros globais do navegador (útil para erros fora do Vue)
window.addEventListener('error', (event) => {
  console.error('🔥 Erro global capturado:', event.message, event.error?.stack)
})

// Captura promessas rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  console.error('🔥 Promessa não tratada:', event.reason)
  // event.preventDefault()   ← só use se quiser realmente impedir o log padrão
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

// ╔══════════════════════════════════════════════╗
// ║          Error Handler Global do Vue         ║
// ╚══════════════════════════════════════════════╝
app.config.errorHandler = (err, instance, info) => {
  console.error('=== Vue Error Handler ===')
  console.error('Erro:', err)
  console.error('Info:', info)

  // Nome do componente (funciona na maioria dos casos)
  const componentName =
    instance?.$options?.name ||
    instance?.type?.name ||
    instance?.type?.__name ||
    'componente anônimo'

  console.log('Componente afetado:', componentName)

  // Props do componente (muito útil para debug)
  if (instance?.props) {
    console.log('Props:', { ...instance.props })
  }

  // Stack do erro (mais detalhado)
  if (err instanceof Error && err.stack) {
    console.log('Stack:', err.stack)
  }

  // Opcional: pausa a execução para você inspecionar no devtools
  // debugger
}

app.use(router)
app.use(pinia)

app.mount('#app')
